<template>
    <div class="metro" v-if="loaded">
        <v-container fluid class="pb-0">
            <v-row align="center" class="link-section-header">
                <v-col cols="12" class="text-center">
                    <v-img src="../assets/img/logo-link-blanco.png" max-width="300px" class="mx-auto"></v-img>
                    <div class="white--text mx-auto mt-6" style="max-width: 550px" v-html="linkSingleton.introduccionBloque1"></div>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" md="6" class="pa-0">
                    <v-img :src="'https://nncms.actstudio.xyz/'+linkSingleton.imagenBloque1.path" width="100%" eager>
                        <transition name="fade-transition">
                            <v-img :src="'https://nncms.actstudio.xyz/'+linkSingleton.mapaMetroLink.path" width="100%" height="100%" v-if="mapOverlap" eager></v-img>
                        </transition>
                    </v-img>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row justify="center">
                        <v-col cols="7" class="py-12">
                            <div v-html="linkSingleton.descripcionBloque1">
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div style="position: relative;">
                <v-row>
                    <v-col cols="12" class="pa-12 link-bg text-center">
                        <!-- <v-img src="../assets/img/logo-next-blanco.png" max-width="300px" class="mx-auto"></v-img> -->
                        <h2 class="white--text pa-12">{{linkSingleton.textoPreguntaMapa}}</h2>
                    </v-col>
                    <div class="d-inline-block" style="position: absolute; top: 0px; right: 50%; transform: translateX(50%) translateY(-50%)">
                        <v-btn fab color="#5C2FAF" :ripple="false" @mouseover="mapOverlap = true" @mouseleave="mapOverlap = false">
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                    </div>
                </v-row>
            </div>

            <div v-if="false" style="position: relative;">
                <v-row>
                    <v-col cols="6" style="background: linear-gradient(90deg, rgba(236,82,155,1) 0%, rgba(236,78,121,1) 50%, rgba(237,73,82,1) 100%);" class="pa-12">
                        <v-img src="../assets/img/logo-next-blanco.png" max-width="300px" class="mx-auto"></v-img>
                    </v-col>
                    <v-col cols="6" style="background: linear-gradient(90deg, rgba(1,167,172,1) 0%, rgba(0,161,140,1) 50%, rgba(0,156,109,1) 100%);" class="pa-12">
                        <v-img src="../assets/img/logo-link-blanco.png" max-width="300px" class="mx-auto"></v-img>
                    </v-col>
                    <div class="d-inline-block" style="position: absolute; top: 50%; right: 50%; transform: translateX(50%) translateY(-50%)">
                        <v-btn fab color="#5C2FAF" :ripple="false" @mouseover="mapOverlap = true" @mouseleave="mapOverlap = false">
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                    </div>
                </v-row>
            </div>
            <!-- <v-row>
                <v-col class="pa-12">
                    <div v-html="linkSingleton.texto" style="max-width: 600px" class="mx-auto text-center">

                    </div>
                </v-col>
            </v-row> -->

            <v-row class="link-service-container" style="height: auto;">
                <v-col cols="12" md="6" class="white--text py-12">
                    <v-row justify="center">
                        <v-col cols="10">
                            <v-img :src="'https://nncms.actstudio.xyz/'+linkSingleton.iconoSeccionIzquierda.path" max-width="55px" class="mx-auto"></v-img>
                            <div class="link-last-text py-6" v-html="linkSingleton.ultimaSeccionIzquierda">

                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6" style="background-color: #01a7ac" class="py-12">
                    <v-row align="center" justify="center" class="my-0">
                        <v-col cols="10" class="white--text">
                            <v-img :src="'https://nncms.actstudio.xyz/'+linkSingleton.iconoSeccionDerecha.path" max-width="55px" class="mx-auto"></v-img>
                            <div class="link-last-text py-6" v-html="linkSingleton.ultimaSeccionDerecha">

                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            
        </v-container>

    </div>
</template>

<script>
export default {
    data() {
        return {
            linkSingleton: {
                imagenBloque1:{
                    path: ''
                }
            },
            loaded: false,
            mapOverlap: false
        }
    },
    mounted: function () {
        if (this.locale == "en") {
            fetch('https://nncms.actstudio.xyz/api/singletons/get/Link',{
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    lang: "en", // return normalized language fields (fieldA_de => fieldA)
                }),
            })
            .then(data => data.json())
            .then(data => this.linkSingleton = data)
            .then(() => this.loaded = true);
        }else{
            fetch('https://nncms.actstudio.xyz/api/singletons/get/Link')
            .then(data => data.json())
            .then(data => this.linkSingleton = data)
            .then(() => this.loaded = true);

        }
    },
    computed: {
        locale: function () {
            return this.$i18n.locale;
        },
    },
    watch: {
        locale: function () {
            if (this.locale == "en") {
                fetch('https://nncms.actstudio.xyz/api/singletons/get/Link',{
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        lang: "en", // return normalized language fields (fieldA_de => fieldA)
                    }),
                })
                .then(data => data.json())
                .then(data => this.linkSingleton = data)
                .then(() => this.loaded = true);
            }else{
                fetch('https://nncms.actstudio.xyz/api/singletons/get/Link')
                .then(data => data.json())
                .then(data => this.linkSingleton = data)
                .then(() => this.loaded = true);

            }
        }
    }
}
</script>